import React from "react";
import { useLocation } from "react-router-dom";

import reduceChildRoutes from "./reduceChildRoutes";

const SidebarNavList = (props) => {
  const { pages, depth } = props;
  const router = useLocation();
  const currentRoute = router.pathname;
  const childRoutes = pages.reduce(
    (items, page, i) =>
      reduceChildRoutes({ items, page, currentRoute, depth, i }),
    []
  );
  return <React.Fragment>{childRoutes}</React.Fragment>;
};

export default SidebarNavList;
